import React from 'react'
import PropTypes from 'prop-types'
import styles from 'components/Onboarding/FormStyles.module.scss'
import classnames from 'classnames'
import {
  NumberFormField,
} from 'belle-js'
import {
  currencyValidation
} from 'utils/fieldValidations'
import AdditionalDetailsFormSection from '../AdditionalDetailsFormSection'

const EmployerContributions = (props) => {
  const employerContributionsDescription = `
    Each year, the Employer shall make the Matching Contributions or
    Non-Elective Contributions to the SIMPLE IRA of Participants in
    accordance with the rules described in Section 4.02 of the Plan.
    For any year the Employer makes Non-Elective Contributions,
    such contributions will be made on behalf of each Participant
    who has at least`

  const conditionalSeparatorDark = classnames(
    styles.inputSeparatorMargin,
    styles.conditionalfieldSubTextDatk
  )

  const { data } = props

  return (
    <AdditionalDetailsFormSection
      title="Employer Contributions"
      description={employerContributionsDescription}
      showBottomLine={false}>
      <div className={styles.conditionalDropdownMargin}>
        <div className={styles.inputWrapper}>
          <NumberFormField
            format="currency"
            allowDecimal={true}
            name="simpleMinCompForEmployerContrib"
            className={styles.FormFieldInSection}
            placeholder="0"
            validations={currencyValidation.rules}
            validationErrors={currencyValidation.messages}
            value={data.simpleMinCompForEmployerContrib}
            required={false}
            testId="simpleMinCompForEmployerContrib" />
        </div>
      </div>
      <div className={conditionalSeparatorDark}>
          of Compensation for such year.
      </div>
      <div className={styles.contributionsHelpText}>
          Enter a dollar amount no less than the amount entered above under the
          Eligibility and Participant Requirements, if applicable,
          and no greater than $5,000
      </div>
    </AdditionalDetailsFormSection>
  )
}

EmployerContributions.propTypes = {
  data: PropTypes.object.isRequired
}

export default EmployerContributions



// WEBPACK FOOTER //
// ./src/components/Onboarding/AdditionalDetails/EmployerContributions/EmployerContributions.jsx